import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { RouteStore } from 'bernie-core';

import { SearchResultsStore } from 'stores/search-results-store';

import { classNames } from 'uitk-react-utils';

import { PlaybackFilterPill } from './playback-filter-pill';

export interface PlaybackFilterProps {
  centerPills?: boolean;
  wrapPills?: boolean;
  searchResults?: SearchResultsStore;
  routeStore?: RouteStore;
  analytics?: any;
}

@inject('searchResults', 'routeStore', 'analytics')
@observer
export class PlaybackFilter extends React.Component<PlaybackFilterProps, {}> {
  public render() {
    const { analytics, routeStore, searchResults, wrapPills, centerPills } = this.props;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const isLoading = searchResults && searchResults.isLoading;
    const pills = sortAndFilter && sortAndFilter.pills;
    const defaults = sortAndFilter && sortAndFilter.defaults;

    let playbackPills = null;

    if (pills && pills.length > 0) {
      playbackPills = pills.map(pill => (
        <PlaybackFilterPill
          key={`playback-filter-${pill.name}-${pill.value}`}
          pill={pill}
          disabled={isLoading}
          routeStore={routeStore}
          defaults={defaults}
          analytics={analytics}
        />
      ));

      const classes = classNames(
        {
          'uitk-scroll-horizontal': !wrapPills,
          'uitk-flex-wrap': wrapPills,
          'uitk-flex-justify-content-center': centerPills
        },
        'uitk-flex playback-pill-grid'
      );

      return <section className={classes}>{playbackPills}</section>;
    }

    return null;
  }
}
